<div
  ctExtractionOcrFormInput
  [activeField]="currentActiveField()"
  class="relative flex h-full max-h-full min-h-0 flex-col gap-4">
  <h3 class="rounded-xl bg-white p-5 font-bold shadow-md">
    Daten-Konsolidierung ({{
      splitEntityIndex() === 0 ? 'Original-Fall' : 'Fall-Kopie ' + splitEntityIndex()
    }})
  </h3>
  @for (section of sections(); track $index) {
    <div class="flex rounded-xl bg-white p-3 shadow-md">
      <span
        class="sticky top-4 bottom-4 col-span-2 rotate-180 self-center text-center font-medium"
        style="writing-mode: vertical-rl">
        {{ section.label }}
      </span>
      <div class="mx-1.5 border-l border-gray-200"></div>
      @if (isFieldGroupModel(section)) {
        <ct-extraction-field-group-extraction-view
          class="w-full"
          [isConsolidation]="true"
          [fieldGroupModel]="section"
          [isActiveSection]="currentActiveSection()?.key === section.key"
          [showHeader]="false"
          [currentFieldModel]="currentActiveFieldModel()"
          [prefillResults]="prefillResults()"
          [focusInputs]="true"
          (currentExtractionFieldChange)="onCurrentFormFieldChange(section, $event)"
          (valueChange)="saveFieldGroupData($event)"
          (statusChange)="changeSectionStatus.emit({ section: section, status: $event })"
          (continue)="handleExtractionContinue()" />
      } @else if (isTableModel(section)) {
        @if (initialTableRowsByKeyResource.hasValue()) {
          <ct-extraction-table-extraction-view
            [formArrayCacheKey]="`consolidation-${splitEntityIndex()}-${section.key}`"
            [enableTableCreationPerDefault]="false"
            [displayHeader]="false"
            [isActiveSection]="currentActiveSectionInComponent()?.key === section.key"
            [capturingConfig]="{
              tableModel: section,
            }"
            (currentExtractionFieldChange)="onCurrentTableFieldChange($event, section)"
            [initialFieldData]="prefillResults().fields"
            [initialRows]="initialTableRowsByKeyResource.value()?.[section.key] ?? []"
            (tableValueChange)="saveTableValues(section.key, $event)"
            (statusChange)="changeSectionStatus.emit({ section: section, status: $event })"
            class="grow" />
        } @else {
          <span>loading rows...</span>
        }
      }
    </div>
  }
</div>
